/**
 * assets/product-recommendations.js
 * Gedrag van sections/product-recommendations.liquid
 *
 * Geknipt uit het {% javascript %}-blok van die section op 16-08-2026, 1:1.
 * Shopify plakte die blokken tot één compiled_assets/scripts.js dat op elke
 * pagina laadde, ook waar de section niet voorkwam. Nu laadt alleen deze
 * section zijn eigen gedrag. Zie ARCHITECTURE.md sectie 11.
 */

/*
 * Eenmalige uitvoering. Shopify voegde alle {% javascript %}-blokken samen tot
 * één bestand dat precies één keer draaide, ongeacht hoe vaak de section op de
 * pagina stond. Deze guard houdt dat gedrag exact gelijk nu elke section zijn
 * eigen script-tag rendert.
 */
(function () {
  'use strict';
  if (window.__vc_productRecommendations) return;
  window.__vc_productRecommendations = true;

  const el = document.querySelector('[data-product-recommendations]');
    if (el) {
      const url = el.dataset.url;
      if (url) {
        fetch(url)
          .then(res => res.text())
          .then(html => {
            const tmp = document.createElement('div');
            tmp.innerHTML = html;
            const rec = tmp.querySelector('[data-product-recommendations]');
            if (rec && rec.innerHTML.trim()) {
              el.innerHTML = rec.innerHTML;
            }
          })
          .catch(() => {});
      }
    }
})();
